/**
 * NavBar
 * Created by zhangdanyang5 on 2018/10/26.
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
    View,
    Platform
} from 'react-native';

import {
    JDText,
    JDTouchableWithoutFeedback
} from '@jdreact/jdreact-core-lib';

import st from './style';
import StaBar from './sta-bar';

/**
 * 状态栏 + 导航条
 * 默认 白底黑字，黑按钮
 * */

class NavBar extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let { title, leftFn = (() => this.context.router.goBack()), center, leftButton, rightButton, rightFn, rightType, textColor, titleBgColor, statusBarColor, compatibleStatusBarColor, barStyle, btnStyle, gradientNavBar } = this.props;
        if (Platform.OS === 'web') {
            title && (document.title = title);
        };
        return (
            <View style={st.container} ref={e => { this.ref = e; }}>
                {/* 状态栏 背景色 statusBarColor: 默认白底; 适配低版本安卓机 请结合使用参数 compatibleStatusBarColor */}
                <StaBar
                    statusBarColor={statusBarColor || titleBgColor || '#fff'}
                    compatibleStatusBarColor={compatibleStatusBarColor || statusBarColor || titleBgColor || '#484848'}
                    barStyle={barStyle} />
                {/* 导航栏 背景色 titleBgColor: 默认白底; 文本与按钮颜色 textColor ,文本默认#232326 按钮默认#848689 */}
                <View style={[st.nav_wrap, !gradientNavBar && st.border, { backgroundColor: titleBgColor || '#fff' }]}>
                    {!center &&
                        <View style={st.center}>
                            <JDText numberOfLines={1} style={[st.nav_tit, { color: textColor || '#232326' }]}>{title}</JDText>
                        </View>
                    }
                    {leftButton ||
                        <JDTouchableWithoutFeedback contentContainerStyle={[st.btn_wrap, btnStyle === 'circle' ? st.btn_wrap_circle : null]} onPress={leftFn}>
                            <View style={[st.back, { borderColor: textColor || '#232326' }]} />
                        </JDTouchableWithoutFeedback>
                    }
                    {!!center && center}
                    {rightButton ||
                        <JDTouchableWithoutFeedback contentContainerStyle={[st.btn_wrap, rightType && btnStyle === 'circle' ? st.btn_wrap_circle : null]} onPress={rightFn}>
                            {!!(rightType === 'more') && (
                                [1, 2, 3].map((x, i) => (
                                    <View style={[st.more_points, { backgroundColor: textColor || '#232326' }]} key={i} />
                                ))
                            )}
                        </JDTouchableWithoutFeedback>
                    }
                </View>
            </View >
        );
    }

    componentDidMount() {
        this.props.onRefNavBar && this.props.onRefNavBar(this);
    }

    setOpacity(opacity) {
        this.ref.setNativeProps({
            opacity
        });
    }
}

NavBar.contextTypes = {
    router: PropTypes.object
};

NavBar.propTypes = {
    // 外部获取当前组件实例的ref
    onRefNavBar: PropTypes.func,
    // 标题栏文字
    title: PropTypes.string,
    // 文本颜色，按钮颜色
    textColor: PropTypes.string,
    // 背景色，默认 #fff, 例如 '#fff'
    titleBgColor: PropTypes.string,
    // 状态栏背景色, 例如 '#fff'
    statusBarColor: PropTypes.string,
    // 适配低版本安卓所需的状态栏背景色, 例如 '#fff'
    compatibleStatusBarColor: PropTypes.string,
    // 对应于 StatusBar barStyle (https://facebook.github.io/react-native/docs/statusbar#statusbarstyle)
    barStyle: PropTypes.oneOf(['default', 'light-content', 'dark-content']),
    // 按钮样式 'circle' 为黑底圆圈
    btnStyle: PropTypes.oneOf(['circle']),
    // 右侧按钮类型
    rightType: PropTypes.string,
    // 左侧按钮功能，默认返回
    leftFn: PropTypes.func,
    // 右侧按钮功能
    rightFn: PropTypes.func,
    // 渲染中间部分
    center: PropTypes.element,
    // 渲染左侧按钮部分
    leftButton: PropTypes.element,
    // 渲染右侧按钮部分
    rightButton: PropTypes.element
};

export default NavBar;
